import React from 'react';
import { useSelector } from "react-redux";
import cn from '../../../../lib/bem';
import { formatAmount2, validateDateFormat } from '../../../../lib/utils/utilitarios';
import ico_moneda from './../../../../assets/icons/ico_moneda.svg';
import ico_billete from './../../../../assets/icons/ico_billete.svg';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import HeaderComponent from '../../../../components/header/header_component';
import ButtonComponent from '../../../../components/button/button_component';
import ModalComponent from '../../../../components/modal/modal_component';
import NotificationComponent from '../../../../components/notification/notification_component';
import {CONTENT_PAG} from '../../constants/content_pag';

import './consuRescaMensaje.scss';

const ConsuRescaMensaje = ({mostrarPagConsultaRescate}) => {
  
    const classes = cn("consuRescaMensaje");
    const infoPoliza  = JSON.parse(sessionStorage.getItem("infoPoliza"));
    const endosoPoliza  = useSelector((state) => state.rootReducers.endosoPoliza);

    const onClickRescatar = () => {
        mostrarPagConsultaRescate(CONTENT_PAG.PAG_CONS)
    }

    const onClickReinversion = () => {
        mostrarPagConsultaRescate(CONTENT_PAG.PAG_REIN)
    }

    const noDisponible = endosoPoliza.datosPoliza?.montoEndoso === 0 || endosoPoliza.datosPoliza?.montoEndoso === null ? false : true;

    return (
        <div className={classes()}>
            <HeaderComponent flagHeaderMobile={false} index={false} title={"Consulta de Rescate"}/>
            {
                endosoPoliza.datosPoliza?.codigoMensaje !== null  && (endosoPoliza.datosPoliza?.codigoMensaje === '002' || endosoPoliza.datosPoliza?.codigoMensaje === '003')?
                    <ModalComponent msgError={endosoPoliza.datosPoliza?.codigoMensaje} />
                :
                    <div>
                        {
                            endosoPoliza.solicitudEndoso === null ?
                                <div className={classes('consuRescaMensajeDiv')}>
                                    <div className={classes('infoDevTitulo')} >
                                        <img src={ico_billete} alt='cobrar' />
                                        <b>Consulta de Rescate</b> 
                                    </div>
                                    <hr className={classes('showDiv')}/>
                                    <div className={classes('infoDevDesc')} >
                                        <p>N° de P&oacute;liza/Plan:</p>
                                        <p>{infoPoliza?.numpol}</p>
                                    </div>
                                    <br/>
                                    <div className={classes('infoDevDesc')} >
                                        <p>Monto de inversi&oacute;n:</p>
                                        <p>{endosoPoliza.datosPoliza?.simboloMoneda}{formatAmount2(endosoPoliza.datosPoliza?.montoInversion + '')}</p>
                                    </div>
                                    <br/>
                                    <div className={classes('infoDevDesc')} >
                                        <p>Fecha de inicio de p&oacute;liza:</p>
                                        <p>{validateDateFormat(endosoPoliza.datosPoliza?.fechaDevengue, 'dd/MM/yyyy')}</p>
                                    </div>
                                    <hr />
                                    <div className={classes('infoDevDesc2')} >
                                        <p>Monto a recibir cuando venza tu p&oacute;liza:</p>
                                        <p>{endosoPoliza.datosPoliza?.simboloMoneda} <span>{formatAmount2(endosoPoliza.datosPoliza?.montoFinalVigencia + '')}</span></p>
                                    </div>
                                    <br/>
                                    <div className={classes('infoDevDesc')} >
                                        <p>Fecha fin de vigencia de p&oacute;liza:</p>
                                        <p>{validateDateFormat(endosoPoliza.datosPoliza?.fechaFinalizacion, 'dd/MM/yyyy')}</p>
                                    </div>
                                    <hr />
                                    <div className={classes('infoDevDesc2')} >
                                        <p>Monto de Rescate disponible:</p>
                                        {
                                            noDisponible ? <p>{endosoPoliza.datosPoliza?.simboloMoneda} <span>{formatAmount2(endosoPoliza.datosPoliza?.montoEndoso + '')}</span></p> : <p className={classes('infoDevDescBold')} >{process.env.REACT_APP_MSG_RESCATE_ERROR_001}</p>
                                        }
                                        
                                    </div>
                                    <br/>
                                    <div>
                                        <NotificationComponent faIcon={faInfo} textNotification={'El monto de rescate presentado corresponde a la fecha de hoy, pero podría variar a futuro dependiendo del día  de presentación de la solicitud. Para poder iniciar el proceso de rescate y en caso tu cuenta no sea del BCP, BBVA, Scotiabank o Interbank necesitarás adjuntar una foto o captura que confirme que eres el titular de la cuenta. Además, durante el proceso, se te enviará un código de verificación a tu mail o teléfono. Para darte más información, contacta con tu asesor.'} tipo="default"/>
                                    </div>
                                    <hr/>
                                    <div>
                                        <NotificationComponent faIcon={faInfo} textNotification={'Si deseas seguir haciendo crecer tu dinero reinvierte con nosotros. Dale clic al botón reinvertir para que un asesor se comunique contigo.'} tipo="default"/>
                                    </div>
                                    <br/><br/>
                                    <div className={classes('buttonsDiv')} >
                                        {
                                            noDisponible ? <div className={classes('buttonsDivWidth')} ><ButtonComponent label={'btnContinuar'} nombre={'Rescatar'} tipo={'button-white'} action={() => onClickRescatar()} disabled={false}/></div> : null
                                        }
                                        <div className={classes('buttonsDivWidth')} ><ButtonComponent label={'btnContinuar'} nombre={'Reinvertir'} tipo={'button-white'} action={() => onClickReinversion()} disabled={false}/></div>
                                    </div>
                                </div>
                            :
                                <div className={classes('consuRescaMensajeDiv')}>
                                    <div className={classes('infoDevTitulo')} >
                                        <img src={ico_moneda} alt='cobrar' />
                                        <b>Consulta de Rescate</b> 
                                    </div>
                                    <hr className={classes('showDiv')}/>
                                    <div className={classes('infoDevDesc')} >
                                        <p>N° de P&oacute;liza/Plan:</p>
                                        <p>{infoPoliza?.numpol}</p>
                                    </div>
                                    <hr />
                                    <div className={classes('infoDevDesc2')} >
                                        <p>Monto de rescate solicitado:</p>
                                        <p>{endosoPoliza.datosPoliza?.simboloMoneda} <span>{formatAmount2(endosoPoliza.solicitudEndoso?.montoSolicitud + '')}</span></p>
                                    </div>
                                    <hr />
                                    <div className={classes('infoDevDesc')} >
                                        <p>Fecha de ingreso de registro:</p>
                                        <p>{validateDateFormat(endosoPoliza.solicitudEndoso?.fechaSolicitud, 'dd/MM/yyyy')}</p>
                                    </div>
                                    <br/><br/>
                                    <div className={classes('infoDevNoti')} >
                                        <NotificationComponent faIcon={null} textNotification={`Tienes una solicitud de rescate pendiente, el número de atención es ${endosoPoliza.solicitudEndoso?.numeroSolicitudServicio}. Ante cualquier duda o consulta comunícate al (01) 513 50000.`} tipo="information"/>
                                    </div>
                                </div>
                        }
                    </div>
            }
        </div>
    );
}



export default ConsuRescaMensaje;
